import { useContext } from 'react';
import WindowEventContext from '../context/window-event-context';
export default function useOnBlur(itemId, options) {
    if (options === void 0) { options = {}; }
    var _a = useContext(WindowEventContext), _onFieldUpdate = _a._onFieldUpdate, logger = _a.logger;
    var _b = options.extractor, extractor = _b === void 0 ? function (evt) { return evt.target.value; } : _b, commitOnOnChange = options.commitOnOnChange;
    var onBlur = function (evt) {
        if (!commitOnOnChange) {
            var val = extractor(evt);
            logger.log("updating " + itemId + " from useOnBlur with", { val: val });
            _onFieldUpdate(itemId, val);
        }
    };
    return {
        onBlur: onBlur,
    };
}
//# sourceMappingURL=useOnBlur.js.map